import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  DEFAULT_LANGUAGE,
  USER_LANGUAGE_STORAGE_KEY,
} from "fe-shared/src/consts";
import { onTranslationReload } from "fe-shared/src/i18nBroadcaster";
import enTranslation from "assets/locales/en/translation.json";
import frTranslation from "assets/locales/fr/translation.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  fr: {
    translation: frTranslation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: USER_LANGUAGE_STORAGE_KEY
    },
    interpolation: {
      escapeValue: false,
    },
  });

onTranslationReload((lang: string) => {
  const selectedLang = localStorage.getItem(USER_LANGUAGE_STORAGE_KEY) ?? i18n.language;
  if(i18n.language === selectedLang) 
    return;
  i18n.changeLanguage(selectedLang);
});

export default i18n;
